import en from './en'
import ru from './ru'
import uk from './uk'

export default {
  en,
  ru,
  uk,
}
